export const LIST_ORGANIZATIONS_URL = "/api/organizations";
export const ORGANISATIONS_ADMIN_URL = "/v2/api/users";
